<template>
  <div class="cluePoolList common_contentBox">
    <div class="common_search">
      <el-row>
        <el-col :xs="12" :sm="12" :md="8" :lg="6" :xl="6">
          <div class="label">线索ID：</div>
          <div class="content">
            <el-input v-model="form.leadId" placeholder="请输入" />
          </div>
        </el-col>
        <el-col :xs="12" :sm="12" :md="8" :lg="6" :xl="6">
          <div class="label">客户单位：</div>
          <div class="content">
            <el-input v-model="form.unit" placeholder="请输入" />
          </div>
        </el-col>
        <el-col :xs="12" :sm="12" :md="8" :lg="6" :xl="6">
          <div class="label">活动名称：</div>
          <div class="content">
            <el-input v-model="form.activityName" placeholder="请输入" />
          </div>
        </el-col>
        <el-col :xs="12" :sm="12" :md="8" :lg="6" :xl="6">
          <div class="label">线索来源：</div>
          <div class="content">
            <el-select v-model="form.leadSourceCode" clearable placeholder="请选择">
              <el-option
                v-for="item in leadSourceOptions"
                :key="item.key"
                :label="item.value"
                :value="item.key"
              />
            </el-select>
          </div>
        </el-col>
        <el-col :xs="12" :sm="12" :md="8" :lg="6" :xl="6">
          <div class="label">客户姓名：</div>
          <div class="content">
            <el-input v-model="form.customerName" placeholder="请输入" />
          </div>
        </el-col>
        <el-col :xs="12" :sm="12" :md="8" :lg="6" :xl="6">
          <div class="label">联系电话：</div>
          <div class="content">
            <el-input v-model="form.phone" placeholder="请输入" />
          </div>
        </el-col>
        <el-col :xs="12" :sm="12" :md="8" :lg="6" :xl="6">
          <div class="label">线索分类：</div>
          <div class="content">
            <el-select v-model="form.leadTypeCode" clearable placeholder="请选择">
              <el-option
                v-for="item in leadTypeOptions"
                :key="item.key"
                :label="item.value"
                :value="item.key"
              />
            </el-select>
          </div>
        </el-col>
        <el-col :xs="12" :sm="12" :md="8" :lg="6" :xl="6">
          <div class="label">线索池：</div>
          <div class="content">
            <el-select
              clearable
              v-model="form.poolId"
              :loading="poolLoading"
            >
              <el-option v-for="(item, index) in poolOptions" :key="index" :label="item.value" :value="item.key" />
            </el-select>
          </div>
        </el-col>
        <el-col :xs="12" :sm="12" :md="8" :lg="6" :xl="6">
          <div class="label">线索上传时间：</div>
          <div class="content">
            <el-date-picker
              v-model="form.time"
              type="daterange"
              range-separator="-"
              start-placeholder="开始日期"
              end-placeholder="结束日期"
              format="yyyy-MM-dd"
            />
          </div>
        </el-col>
        <el-col :xs="12" :sm="12" :md="8" :lg="6" :xl="6">
          <div class="label">线索状态：</div>
          <div class="content">
            <el-select v-model="form.poolStat" clearable placeholder="请选择">
              <el-option
                v-for="item in leadStatOptions"
                :key="item.key"
                :label="item.value"
                :value="item.key"
              />
            </el-select>
          </div>
        </el-col>
        <el-col :xs="12" :sm="12" :md="8" :lg="6" :xl="6" />
        <div class="btnBar">
          <el-button plain @click="reset">重置</el-button>
          <el-button type="primary" @click="searchBtn">搜索</el-button>
        </div>
      </el-row>
    </div>
    <div class="common_btnBar">
      <!-- <el-button plain @click="importHandle">导入线索</el-button> -->
      <el-button type="primary" @click="exportHandle" v-if="btnPermission.indexOf('导出') >= 0">导出线索</el-button>
      <el-button plain @click="importHandle" v-if="btnPermission.indexOf('导入') >= 0" v-show="form.poolId === 'customer_pool'">导入线索</el-button>
      <el-button plain @click="collectHandle" v-if="btnPermission.indexOf('领取') >= 0">批量领取</el-button>
      <el-button plain @click="batchShareHandle" v-if="btnPermission.indexOf('分配') >= 0">批量分配</el-button>
      <el-button plain @click="deleteHandle" v-if="btnPermission.indexOf('删除') >= 0">批量删除</el-button>
    </div>
    <commonTable ref="cluePoolListTable" />
    <!-- 导入线索 -->
    <importClueDialog
      :import-clue-show="importClueShow"
      @dialogCloseHandle="importClueClose"
      @submitHandle="importClueSubHandle"
    />
    <!-- 分配线索 -->
    <shareClueDialog
      :selected-pool-list="selectedPoolList"
      :share-clue-show="shareClueShow"
      @dialogCloseHandle="shareClueClose"
      @submitHandle="shareClueSubHandle"
    />
  </div>
</template>

<script>
import commonTable from '@/components/commonTable';
import { TableColumns, TableRow } from '@/utils/tableOptions';
import importClueDialog from './component/cluePoolList/importClueDialog';
import shareClueDialog from './component/cluePoolList/shareClueDialog';
import { cluePoolListApi } from './service';
import { isShowColumn } from '@/utils/utils';
import axios from 'axios';
import requestBaseUrl from '@/API/request/baseUrl';
export default {
  name: 'CluePoolList',
  data () {
    return {
      shareClueShow: false,
      importClueShow: false,
      form: {
        poolType: '1',
        poolConfigType: 'pool'
      },
      tempForm: {
        poolType: '1',
        poolConfigType: 'pool'
      },
      poolLoading: false,
      leadSourceOptions: [],
      leadTypeOptions: [],
      poolOptions: [],
      leadStatOptions: [],
      btnPermission: [],
      selectedPoolList: []
    };
  },
  components: {
    commonTable,
    importClueDialog,
    shareClueDialog
  },
  methods: {
    deleteHandle (row) {
      let selectRow = this.$refs.cluePoolListTable.getCheckboxRecords();
      if (!row.leadId && selectRow.length < 1) {
        this.$message.error('请选择要删除的线索');
        return;
      }
      let tipsText = '确定是否删除该线索';
      let params = [];
      if (!row.leadId) {
        tipsText = `确定删除${selectRow.length}条线索`;
        params = selectRow.map(item => {
          return item.leadId;
        });
      } else {
        params = [row.leadId];
      }
      this.$confirm(tipsText, '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.$refs.cluePoolListTable.loading = true;
        cluePoolListApi.deleteLead(params).then(res => {
          if (res.status === '200') {
            this.searchBtn();
            this.$message({
              type: 'success',
              message: '删除成功!'
            });
          }
          this.$refs.cluePoolListTable.loading = false;
        });
      }).catch(() => {

      });
    },
    remoteMethod (query) {
      this.poolLoading = true;
      cluePoolListApi.getPoolOptionList(1, query).then(res => {
        if (res.status === '200') {
          if (res.data && res.data.length > 0) {
            this.poolOptions = res.data;
          } else {
            this.poolOptions = [];
          }
        }
        this.poolLoading = false;
      });
    },
    shareClueSubHandle (data) {
      this.$store.commit('setSubPageLoading', true);
      cluePoolListApi.distribute(data).then(res => {
        if (res.status === '200') {
          this.$message.success('操作成功');
          this.searchBtn();
          this.shareClueShow = false;
        }
        this.$store.commit('setSubPageLoading', false);
      });
    },
    detailsJump (row) {
      this.$router.push({
        path: '/clueDetails',
        query: {
          leadId: row.leadId,
          metaActive: '/cluePoolList'
        }
      });
    },
    importClueSubHandle () {
      this.importClueShow = false;
      this.searchBtn();
    },
    importHandle () {
      this.importClueShow = true;
    },
    importClueClose () {
      this.importClueShow = false;
    },
    exportHandle () {
      let selectRowObj = this.$refs.cluePoolListTable.getCheckboxRecords();
      let params = {};
      let tipsText = '';
      // 判断查询结果的总个数是否为0
      if (this.$refs.cluePoolListTable.pageData.total < 1) {
        this.$message.error('占无可导出的线索');
      }
      if (selectRowObj.length < 1) {
        // 如果没有勾选就是导出全部
        params = {
          exportType: '2',
          ...this.form
        };
        tipsText = `确认是否导出全部线索，共${this.$refs.cluePoolListTable.pageData.total}条`;
      } else {
        // 如果勾选则导出勾选项
        params = {
          exportType: '1',
          leadIdList: selectRowObj.map(item => {
            return item.leadId;
          })
        };
        tipsText = `确认是否导出${selectRowObj.length}条线索`;
      }
      this.$confirm(tipsText, '导出', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        axios({
          method: 'post',
          withCredentials: true,
          headers: {
            sysId: window._env_.VUE_APP_SYSID
          },
          url: `${requestBaseUrl}/lead/excel/leadExcel`,
          responseType: 'blob',
          data: params
        }).then(response => {
          let date = new Date().format('yyyyMMddhhmmss');
          // let fileName = window.decodeURI(response.headers['content-disposition'].split('=')[1]);
          let fileName = `线索导出${ date }`;
          let link = document.createElement('a');
          link.href = window.URL.createObjectURL(new Blob([response.data], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=utf-8' }));
          link.target = '_blank';
          link.download = fileName;
          document.body.appendChild(link);
          link.click();
          document.body.removeChild(link);
        });
      }).catch(() => {

      });
    },
    collectHandle (row) {
      let selectRowObj = this.$refs.cluePoolListTable.getCheckboxRecords();
      if (!row.leadId && selectRowObj.length < 1) {
        this.$message.error('请选择需要领取的线索');
        return;
      }
      this.$confirm('是否领取线索至个人私海？', '领取线索', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        let params = [];
        if (row.leadId) {
          params = [row.leadId];
        } else {
          params = selectRowObj.map(item => {
            return item.leadId;
          });
        }
        cluePoolListApi.getClues(params).then(res => {
          if (res.status === '200') {
            this.$message.success('领取成功');
            this.searchBtn();
          }
        });
      }).catch(() => {

      });
    },
    batchShareHandle () {
      let selectRowObj = this.$refs.cluePoolListTable.getCheckboxRecords();
      if (selectRowObj.length > 0) {
        this.selectedPoolList = selectRowObj;
        this.shareClueShow = true;
      } else {
        this.$message.error('请选择需要分配的线索');
      }
    },
    shareClueHandle (row) {
      this.selectedPoolList = [row];
      this.shareClueShow = true;
    },
    shareClueClose () {
      this.shareClueShow = false;
    },
    reset () {
      this.form = {
        poolType: '1',
        poolConfigType: 'pool'
      };
      this.searchBtn();
    },
    searchBtn () {
      this.tempForm = JSON.parse(JSON.stringify(this.form));
      if (this.tempForm.time) {
        this.tempForm.startTime = this.form.time[0].format('yyyy-MM-dd');
        this.tempForm.endTime = this.form.time[1].format('yyyy-MM-dd');
        delete this.tempForm.time;
      }
      if (this.tempForm.time === null) {
        delete this.tempForm.time;
      }
      this.$refs.cluePoolListTable.pageData.pageNum = 1;
      this.$refs.cluePoolListTable.getTableData({ url: '/lead/lead/list/condition', params: this.tempForm });
    },
    loadTable () {
      let tableRow = new TableRow();
      tableRow.push(
        new TableColumns()
          ._width('50px')
          ._others('checkbox')
          ._fixed('left')
      );
      tableRow.push(
        new TableColumns()
          ._title('线索ID')
          ._width('140px')
          ._fixed('left')
          ._cellType('customDom')
          ._cellData({
            formater: ({ row, column }) => {
              return (
                <div>
                  <span class="btnText" onClick={() => { this.detailsJump(row); }}>{ row.leadId }</span>
                </div>
              );
            }
          })
      );
      tableRow.push(
        new TableColumns()
          ._title('线索分类')
          ._width('100px')
          ._data('leadTypeName')
      );
      tableRow.push(
        new TableColumns()
          ._title('活动编号')
          ._width('150px')
          ._data('activityCode')
      );
      tableRow.push(
        new TableColumns()
          ._title('活动分类')
          ._width('100px')
          ._data('activityClassificationName')
      );
      tableRow.push(
        new TableColumns()
          ._title('活动名称')
          ._width('150px')
          ._data('activityName')
      );
      tableRow.push(
        new TableColumns()
          ._title('实际线索等级')
          ._width('130px')
          ._data('classificationActualName')
      );
      tableRow.push(
        new TableColumns()
          ._title('线索上传日期')
          ._width('130px')
          ._data('uploadTime')
          ._cellType('customDom')
          ._cellData({
            formater: ({ row, column }) => {
              let date = row[column.property] ? new Date(row[column.property].replace(/-/g, '/')).format('yyyy-MM-dd') : '';
              return (
                <span>{date}</span>
              );
            }
          })
      );
      tableRow.push(
        new TableColumns()
          ._title('客户单位')
          ._width('130px')
          ._data('unit')
      );
      tableRow.push(
        new TableColumns()
          ._title('联系电话')
          ._width('130px')
          ._data('phone')
      );
      tableRow.push(
        new TableColumns()
          ._title('客户姓名')
          ._width('100px')
          ._data('name')
      );
      tableRow.push(
        new TableColumns()
          ._title('城市')
          ._width('100px')
          ._data('city')
      );
      tableRow.push(
        new TableColumns()
          ._title('行业')
          ._width('100px')
          ._data('industry')
      );
      tableRow.push(
        new TableColumns()
          ._title('产品线')
          ._width('100px')
          ._data('productLine')
      );
      tableRow.push(
        new TableColumns()
          ._title('备注')
          ._width('130px')
          ._data('remark')
          ._offOverFlow(true)
      );
      tableRow.push(
        new TableColumns()
          ._title('线索状态')
          ._width('130px')
          ._fixed('right')
          ._data('statName')
      );
      if (isShowColumn(this.btnPermission, ['领取', '分配'])) {
        tableRow.push(
          new TableColumns()
            ._title('操作')
            ._width('170px')
            ._fixed('right')
            ._cellType('customDom')
            ._cellData({
              formater: ({ row, column }) => {
                return (
                  <div>
                    {
                      row.buttonVO.isDistributeShow ? (
                        <el-button type="text" onClick={() => {
                          this.shareClueHandle(row);
                        }}>
                            分配
                        </el-button>
                      ) : null
                    }
                    {
                      row.buttonVO.isReceiveShow ? (
                        <el-button type="text" onClick={() => {
                          this.collectHandle(row);
                        }}>
                            领取
                        </el-button>
                      ) : null
                    }
                    {
                      row.buttonVO.isDeleteShow ? (
                        <el-button type="text" onClick={() => { this.deleteHandle(row); }}>删除</el-button>
                      ) : null
                    }
                  </div>
                );
              }
            })
        );
      }
      let column = tableRow._cols();
      this.$refs.cluePoolListTable.setColumn(column, {
        checkboxReserve: true
      });
      this.$refs.cluePoolListTable.loadTable({ url: '/lead/lead/list/condition', listKey: 'list', params: this.form });
    },
    getOptionsList () {
      cluePoolListApi.getOptionsList('POOL').then(res => {
        if (res.status === '200') {
          this.leadSourceOptions = res.data.leadSourceOptions;
          this.leadTypeOptions = res.data.leadTypeOptions;
          this.leadStatOptions = res.data.leadStatOptions;
        }
      });
    }
  },
  activated () {
    this.$refs.cluePoolListTable.getTableData({ url: '/lead/lead/list/condition', listKey: 'list', params: this.tempForm });
  },
  mounted () {
    let jurisdiction = this.$store.state.userInfo.permissionDTO.leadModule;
    // 按钮权限
    if (jurisdiction.lead_function) {
      this.btnPermission = jurisdiction.lead_function.lead_function_lead_pool;
    }

    this.getOptionsList();
    this.loadTable();
    this.remoteMethod('');
  }
};
</script>

<style scoped>

</style>
